{
  "navigation": {
    "home": "Home",
    "cues": "Cues",
    "inbox": "Inbox",
    "profile": "Profile"
  },
  "notifications": {
    "someone": "Someone",
    "someoneNearby": "Someone nearby",
    "smallGroup": "Small group",
    "cueReceivedTitle": "{{name}} sent you a Cue",
    "cueReceivedBody": "They are open to a conversation nearby.",
    "cueAcceptedTitle": "{{name}} accepted your Cue",
    "cueAcceptedBody": "Say hello. Your chat is open.",
    "messageTitle": "{{name}} sent you a message",
    "messageBody": "Open your conversation to reply.",
    "groupMessageTitle": "{{name}} in {{groupName}}",
    "groupMessageBody": "Open the group to catch up.",
    "morePeopleTitle": "More people are nearby",
    "onePersonTitle": "Someone new is nearby",
    "morePeopleBody": "and are open to Cues.",
    "onePersonBody": "and open to a Cue.",
    "revealRequestedTitle": "{{name}} wants to share more",
    "revealRequestedBody": "Review the share more request in your conversation.",
    "revealCompletedTitle": "{{name}} chose to share more too",
    "revealCompletedBody": "Additional profile details are now available."
  },
  "cues": {
    "received": "Received",
    "receivedA11y": "Received Cues",
    "sent": "Cue sent",
    "sentA11y": "Sent Cues",
    "newRequests_one": "{{count}} new request",
    "newRequests_other": "{{count}} new requests",
    "viewProfile": "View {{name}}’s profile",
    "accept": "Accept",
    "acceptA11y": "Accept Cue",
    "ignore": "Ignore",
    "ignoreA11y": "Ignore Cue",
    "blockA11y": "Block this person",
    "waiting": "Waiting",
    "waitingBody": "Waiting for them to accept your Cue.",
    "acceptedBadge": "Accepted",
    "acceptedBody": "They accepted your Cue.",
    "openChat": "Open chat",
    "emptyTitle": "No Cues yet",
    "emptyBody": "You’re in control. Accept when it feels right, pass quietly, or block if you need to.",
    "sentTo": "Cue sent to {{name}}",
    "sentBody": "We’ll let you know when they accept.",
    "withdraw": "Withdraw",
    "withdrawA11y": "Withdraw this Cue",
    "withdrawConfirmTitle": "Withdraw this Cue?",
    "withdrawConfirmBody": "Your Cue slot will be available again immediately.",
    "withdrawConfirm": "Withdraw",
    "withdrawFailed": "Couldn’t withdraw that Cue. Try again.",
    "slotsHelp": "A slot frees up as soon as a Cue is withdrawn, declined or expires.",
    "cooldownCancelled": "You recently cancelled a Cue to this person. Try again in {{countdown}}.",
    "cooldownExpired": "Your last Cue to this person expired without a reply. You can try again in {{countdown}}.",
    "countdownUnderMinute": "less than a minute",
    "countdownMinutes_one": "{{count}} minute",
    "countdownMinutes_other": "{{count}} minutes",
    "countdownHours_one": "{{count}} hour",
    "countdownHours_other": "{{count}} hours",
    "countdownPair": "{{major}} {{minor}}"
  },
  "inbox": {
    "active": "active",
    "activeCount_one": "{{count}} active",
    "activeCount_other": "{{count}} active",
    "practiceTitle": "Conversation Practice",
    "openPracticeA11y": "Open Conversation Practice",
    "practiceDescription": "Practice icebreakers, awkward pauses, and follow-ups privately.",
    "practicePrivate": "Kept separate from your other chats.",
    "openConversationA11y": "Open conversation with {{name}}",
    "openGroupA11y": "Open group {{name}}",
    "people_one": "{{count}} person",
    "people_other": "{{count}} people",
    "hereFor": "Here for: {{goals}}",
    "noLongerActive": "No longer active",
    "sayHi": "Say hi",
    "groupPreview": "{{count}} / {{max}} people · {{minutes}} min left",
    "emptyTitle": "No messages yet",
    "emptyBody": "Send a Cue to someone and start conversations when you’re ready.",
    "tabActive": "Active",
    "tabInactive": "Inactive",
    "tabActiveA11y": "Show active conversations",
    "tabInactiveA11y": "Show inactive conversations ({{total}})",
    "inactivePreview": "Inactive",
    "inactiveWarning": "There haven’t been any new messages here for 29 days. It will move to Inactive in 24 hours. Nothing will be deleted.",
    "reopenWaiting": "Waiting for them to accept",
    "reopenAsked": "They asked to reopen this conversation",
    "inactiveEmptyTitle": "No inactive conversations",
    "inactiveEmptyBody": "Conversations move here after 30 days without a back-and-forth. Nothing is deleted, and either person can ask to reopen them.",
    "tabOpen": "Open",
    "tabOpenA11y": "Show contacts who are open to chat ({{total}})",
    "openHeading": "Your contacts who are open to chat",
    "openEmpty": "Nobody is open right now",
    "openEmptyBody": "When someone you’re talking to says they’re free, they show up here.",
    "openImOpen": "I’m Open",
    "openImOpenFor": "I’m Open · for {{time}}",
    "openImOpenA11y": "Tell your contacts you’re open to chat",
    "openTurnOffA11y": "Stop being open to chat",
    "openDurationTitle": "How long?",
    "openDurationMinutes": "{{count}} minutes",
    "openDurationHour": "1 hour",
    "openDurationHours": "{{count}} hours",
    "openPeerA11y": "open to chat",
    "openFailedTitle": "Couldn’t check who’s open",
    "openFailedBody": "That’s a problem on our side, not a sign that nobody’s around."
  },
  "chat": {
    "viewProfileA11y": "View {{name}}’s public profile",
    "revealedStatus": "Shared more",
    "you": "You",
    "them": "Them",
    "loadEarlier": "Load earlier messages",
    "loadingEarlier": "Loading earlier messages…",
    "requestReveal": "Request to share more",
    "acceptReveal": "Accept to share more",
    "optionsA11y": "Conversation options",
    "revealed": "You both chose to share more",
    "revealedDetails": "You both chose to share more — {{name}}{{proximity}}",
    "revealPending": "Share more request sent — waiting for them to agree",
    "revealReceived": "Share more request received — waiting for you to agree",
    "revealPendingShort": "Pending",
    "connected": "You’re connected. Break the ice.",
    "messagesUnavailable": "Couldn’t load messages. Tap to retry.",
    "replyingTo": "Replying to",
    "replyingToAuthor": "Replying to {{author}}",
    "cancelReplyA11y": "Cancel reply",
    "messagePlaceholder": "Message…",
    "closeOptionsA11y": "Close conversation options",
    "revealDescription": "Ask to reveal a bit more about each other.",
    "photoExchange": "Exchange a photo",
    "photoExchangeHint": "You’ll only see each other’s photo if you both agree.",
    "photoExchanged": "Photo exchanged",
    "photoExchangedHint": "You both chose to share a photo.",
    "photoRespond": "Share a photo back",
    "photoRespondHint": "They’ve shared one. Yours is sent only if you agree.",
    "photoWaiting": "Waiting for {{name}}",
    "photoWaitingHint": "They’ll see your photo only if they share one too.",
    "photoExhaustedHint": "You’ve used both of your requests.",
    "photoRequestTitle": "{{name}} would like to exchange a photo",
    "photoRequestBody": "Share one back and you’ll both see them at the same time. Neither photo is shown unless you both agree.",
    "photoShareBack": "Share a photo",
    "photoNotNow": "Not now",
    "photoWithdraw": "Withdraw request",
    "photoRejectedTitle": "Choose another photo",
    "photoRejectedBody": "We couldn’t use this image. Try a different one.",
    "photoGoneTitle": "That request has closed",
    "photoGoneBody": "It expired or was answered before your photo went through. Your photo wasn’t shared.",
    "photoUnavailable": "This photo is no longer available.",
    "photoRetry": "Couldn’t load. Tap to retry.",
    "photoOpenA11y": "Open photo",
    "photoDelete": "Delete photo",
    "photoDeleteTitle": "Delete this photo?",
    "photoDeleteBody": "It will be removed for both of you and cannot be restored. You won’t get the exchange back.",
    "clearMessages": "Clear messages",
    "clearDescription": "Remove your copy of this conversation. They'll still have theirs.",
    "clearConfirmTitle": "Clear these messages?",
    "clearConfirmBody": "This removes your copy for good. The other person keeps theirs, and they won’t be told.",
    "clearConfirm": "Clear messages",
    "clearedTitle": "Messages cleared.",
    "clearedBody": "Your copy is gone. The conversation is still open.",
    "exitQuietly": "Exit quietly",
    "exit": "Exit",
    "exitDescription": "They won’t be notified. This moves to Inactive, and you can pick it back up quietly.",
    "blockTitle": "Block {{name}}?",
    "blockDescription": "They won’t be notified, but they won’t be able to see or Cue you again.",
    "reportDescription": "Report this person for safety or policy reasons.",
    "typingA11y": "{{name}} is typing",
    "reactA11y": "React to message",
    "removeReactionA11y": "Remove reaction",
    "reactWithA11y": "React with {{reaction}}",
    "pickEmojiA11y": "Pick an emoji",
    "blockedTitleShort": "Blocked.",
    "endedTitle": "Moved to Inactive.",
    "blockedBodyShort": "They won’t be able to see or Cue you again.",
    "endedBody": "Nothing was deleted. You’ll find it in your Inactive tab.",
    "publicProfile": "Public profile",
    "closed": "This conversation has closed.",
    "peerUnavailable": "This person has deactivated their account. Your conversation is still here if they come back.",
    "peerGone": "This person is no longer on Opncue. The conversation is still here for you to read.",
    "inactiveWarning": "There haven’t been any new messages here for 29 days. It will move to Inactive in 24 hours. Nothing will be deleted.",
    "inactiveTitle": "This conversation is inactive",
    "inactiveBody": "Your conversation is still here, but you’ll both need to agree before messaging can continue.",
    "reopenAsk": "Ask to reopen",
    "reopenPending": "Waiting for them to accept.",
    "reopenCooldown": "You can ask to reopen this again later.",
    "reopenRequestTitle": "{{name}} would like to reopen your conversation",
    "reopenRequestBody": "Accept to move it back to Active and continue messaging.",
    "reopenAccept": "Reopen conversation",
    "reopenDecline": "Not now",
    "reopenFailedTitle": "Could not update this conversation",
    "reopenFailedBody": "Try again in a moment.",
    "emojiSearch": "Search emoji",
    "emojiNone": "No emoji found",
    "emojiPickerClose": "Close emoji picker",
    "emojiGroupSmileys": "Smileys",
    "emojiGroupPeople": "People",
    "emojiGroupNature": "Nature",
    "emojiGroupFood": "Food & drink",
    "emojiGroupActivity": "Activity",
    "emojiGroupTravel": "Travel",
    "emojiGroupObjects": "Objects",
    "emojiGroupSymbols": "Symbols",
    "emojiGroupFlags": "Flags",
    "blockedTitle": "You blocked this person",
    "blockedBody": "Your messages are still here. Unblocking puts you both back in each other's list — to talk again, one of you sends a Cue and the other accepts.",
    "unblock": "Unblock",
    "unblockConfirmTitle": "Unblock {{name}}?",
    "unblockConfirmBody": "You'll be able to see each other again. To talk, one of you sends a Cue and the other accepts.",
    "leftTitle": "You left this conversation",
    "leftBody": "Your messages are still here. Pick it back up whenever you like — anything they sent while you were away stayed with them.",
    "resume": "Pick it back up",
    "messagePending": "Message waiting to send",
    "messageQueueFullTitle": "Too many messages waiting",
    "messageQueueFullBody": "Some of your messages haven't sent yet. Wait for them to go through before adding more.",
    "system": {
      "revealRequestSender": "Share more request sent. If they agree, you'll both unlock more profile details",
      "revealRequestReceiver": "You have received a share more request. If you agree, click on share button above and you'll both unlock more profile details",
      "revealCompleted": "Additional profile details are now available, click on profile to see more",
      "reopened": "You're both back. You can send messages again.",
      "photoExchanged": "📷 Photo"
    }
  },
  "groups": {
    "endedTitle": "Small Group ended",
    "endedBody": "This temporary group is no longer active.",
    "updateFailedTitle": "Unable to update group",
    "backHomeA11y": "Back to home",
    "summary": "{{count}} / {{max}} people · {{minutes}} min left",
    "leave": "Leave",
    "endsSoon": "This Small Group is about to end.",
    "endsIn_one": "This Small Group ends in {{count}} minute.",
    "endsIn_other": "This Small Group ends in {{count}} minutes.",
    "empty": "Say hello, get to know the group, and make a plan.",
    "suggestSpot": "Suggest meetup spot",
    "ready": "I’m ready to say hi",
    "messagePlaceholder": "Message the group…",
    "closeSpotsA11y": "Close meetup spots",
    "suggestSpotTitle": "Suggest a meetup spot",
    "nearEntrance": "Near the entrance",
    "byCounter": "By the counter",
    "atMyTable": "At my table",
    "custom": "Custom",
    "ownSpot": "Or enter your own",
    "customSpotPlaceholder": "e.g. Front window seats",
    "sendCustomA11y": "Send custom meetup spot",
    "send": "Send",
    "oneTyping": "{{name}} is typing",
    "manyTyping": "{{count}} people are typing",
    "you": "You",
    "menu": {
      "open": "Group options",
      "closeA11y": "Close group options",
      "members": "Members",
      "suggestMeetupSpot": "Suggest meetup spot",
      "leaveGroup": "Leave group",
      "reportGroup": "Report group",
      "invite": "Invite someone",
      "range": "Change range",
      "deleteGroup": "Delete group"
    },
    "members": {
      "title": "Members",
      "hostLabel": "Host",
      "viewProfile": "View profile",
      "remove": "Remove from group",
      "report": "Report",
      "onlyYou": "It’s just you here for now.",
      "actions": "More options for {{name}}",
      "message": "Message",
      "cue": "Send a Cue",
      "cueUnavailable": "Not accepting Cues here",
      "cueSent": "Cue sent to {{name}}",
      "consentTitle": "Let members Cue you",
      "consentHint": "Anyone here can ask to start a private conversation. Turning this off later won’t withdraw Cues already sent."
    },
    "remove": {
      "confirmTitle": "Remove this person from the group?",
      "confirmBody": "They won’t be able to send new messages or rejoin this Cue. This only affects this group.",
      "confirmAction": "Remove",
      "success": "Removed from group."
    },
    "removed": {
      "title": "You’re no longer in this group",
      "body": "You can’t send messages here anymore. This is your copy of the conversation, and you can still report a problem if needed.",
      "close": "Close",
      "report": "Report a problem"
    },
    "left": {
      "title": "You left this group",
      "body": "This is your copy of the conversation. Anything said after you left stays with the group.",
      "rejoin": "Join again",
      "notice": "It’s in Inactive. You can still read it, and join again while it’s running."
    },
    "leaveConfirm": {
      "title": "Leave this group?",
      "body": "You won’t be able to send new messages here, but you can still report a problem if needed.",
      "hostBody": "You’re hosting this group. If you leave, the Cue will close to new people, but the existing chat can continue until it expires.",
      "action": "Leave group"
    },
    "report": {
      "title": "Report group"
    },
    "meetup": {
      "easyToFind": "Somewhere easy to find",
      "quieter": "Somewhere quieter",
      "custom": "Custom spot",
      "draftConflict": {
        "title": "You already have a message started",
        "replace": "Replace draft",
        "append": "Add after current draft",
        "cancel": "Cancel"
      },
      "drafts": {
        "nearEntrance": "Should we meet near the entrance in a few minutes?",
        "easyToFind": "Should we pick somewhere easy for everyone to find?",
        "quieter": "Would somewhere quieter work better?",
        "custom": "Should we meet {{spot}} in a few minutes?"
      }
    },
    "profileUnavailable": {
      "title": "Profile unavailable",
      "body": "This profile is no longer available."
    },
    "invite": {
      "shareMessage": "Join my Small Group on Opncue: {{name}}",
      "eyebrow": "Small Group invite",
      "members": "{{count}} of {{max}} people",
      "range": "For people within {{distance}}",
      "join": "Join Small Group",
      "open": "Open group",
      "browse": "Find Small Groups near you",
      "tryAgain": "Check again",
      "missingTitle": "This invite has expired",
      "missingBody": "The Small Group has ended or the link is no longer valid.",
      "outOfRangeTitle": "This Small Group is for people nearby",
      "outOfRangeBody": "To keep Small Groups local and make it realistic for members to meet, you can only join when you are within the group’s range.\n\nYou can try again when you’re nearby, or find a Small Group closer to you.",
      "fullTitle": "This Small Group is full",
      "fullBody": "Every seat is taken. Try another Small Group nearby.",
      "endedTitle": "This Small Group has ended",
      "endedBody": "Small Groups run for a set time and this one has finished.",
      "notVisibleTitle": "Turn on visibility to join",
      "notVisibleBody": "Small Groups are for meeting people around you, so you need to be visible before joining.",
      "noLocationTitle": "Share your location to join",
      "noLocationBody": "We need your location to check you are within the group’s range.",
      "removedTitle": "You can’t rejoin this Small Group",
      "removedBody": "You were removed from this group."
    },
    "range": {
      "title": "Who can join",
      "hint": "People within {{distance}} can see and join this group. Members already in stay in.",
      "done": "Done"
    },
    "ended": {
      "banner": "This group has ended. You can read the messages, but no one can post.",
      "deleteConfirmTitle": "Delete this group?",
      "deleteConfirmAction": "Delete",
      "preview": "Group ended"
    },
    "system": {
      "joined": "{{name}} joined the group.",
      "left": "{{name}} left the group.",
      "readyToSayHi": "{{name}} is ready to say hi.",
      "groupReadyToMeet": "Looks like this group is ready to meet. Say hi in person when you're comfortable.",
      "suggestedSpot": "{{name}} suggested meeting {{spot}}.",
      "suggestedQuoted": "{{name}} suggested: {{spot}}",
      "someone": "Someone"
    }
  },
  "conversationDeck": {
    "openA11y": "Open Conversation Deck",
    "title": "Conversation Deck",
    "subtitle": "Private ideas for when you're not sure what to say.",
    "closeA11y": "Close Conversation Deck",
    "categoryA11y": "Conversation Deck category {{category}}",
    "categorySelectedA11y": "Conversation Deck category {{category}}, selected",
    "addToMessage": "Add",
    "addToMessageA11y": "Add this prompt to your message draft",
    "another": "Another idea",
    "anotherA11y": "Show another idea",
    "draftTitle": "You already have a draft",
    "draftBody": "Choose how to add this prompt so your current message is not overwritten.",
    "replaceDraft": "Replace draft",
    "replaceDraftA11y": "Replace your current draft with this prompt",
    "addAfterDraft": "Add after draft",
    "addAfterDraftA11y": "Add this prompt after your current draft",
    "cancelDraft": "Cancel",
    "categories": {
      "start": "Start",
      "keep_going": "Keep going",
      "fun": "Fun",
      "get_to_know": "Get to know",
      "go_deeper": "Go deeper",
      "make_a_plan": "Make a plan",
      "wrap_up": "Wrap up"
    },
    "prompts": {
      "start_currentHighlight": "What has been the best part of your day so far?",
      "start_todayTinyWin": "What is one tiny win you are claiming today?",
      "start_weekendEnergy": "What kind of weekend energy are you hoping for?",
      "start_foodOpinion": "What is a food opinion you will defend with unreasonable confidence?",
      "start_musicMood": "What song has been matching your mood lately?",
      "start_outdoors": "Have you had a good outside moment recently?",
      "keep_going_moreAboutThat": "Tell me more about that. What made it stand out?",
      "keep_going_bestPart": "What was the best part of that for you?",
      "keep_going_surprising": "What surprised you most about it?",
      "keep_going_related": "That reminds me of something. Want to trade related stories?",
      "keep_going_story": "I feel like there is a story there. What happened?",
      "keep_going_nextQuestion": "I am curious where to take this next. What should I ask you?",
      "fun_sillySkill": "What is a completely useless skill you would still be proud to have?",
      "fun_minorDebate": "Tiny debate: what is better, perfect snacks or perfect lighting?",
      "fun_themeSong": "If today had a theme song, what would it be?",
      "fun_movieSnack": "What movie snack combination says the most about a person?",
      "fun_tinyAdventure": "What counts as a tiny adventure for you?",
      "fun_badTake": "What is your most harmless bad take?",
      "get_to_know_weekTexture": "What has the texture of your week been like? Calm, chaotic, weird, something else?",
      "get_to_know_comfortThing": "What is one small thing that reliably makes you feel more like yourself?",
      "get_to_know_smallJoy": "What small joy have you been underrating lately?",
      "get_to_know_learning": "What are you learning about yourself these days?",
      "get_to_know_localFavorite": "What is a local place you think deserves more love?",
      "get_to_know_freeAfternoon": "If you got a free afternoon with no obligations, what would you do first?",
      "go_deeper_energyLately": "What has been giving you energy lately, and what has been taking it?",
      "go_deeper_feelingProud": "What is something you are quietly proud of?",
      "go_deeper_changedMind": "What is something you have changed your mind about over time?",
      "go_deeper_values": "What is a value you notice yourself caring about more than you used to?",
      "go_deeper_support": "What kind of support do you appreciate most from people?",
      "go_deeper_goodDay": "What makes a day feel genuinely good to you?",
      "make_a_plan_coffee": "Would you be up for a low-key coffee sometime soon?",
      "make_a_plan_walk": "Would a short walk sometime feel easier than sitting somewhere?",
      "make_a_plan_window": "What kind of time window usually works best for you?",
      "make_a_plan_lowKey": "If we made a plan, what would feel relaxed and easy?",
      "make_a_plan_nextStep": "What would be a good next step from here?",
      "make_a_plan_public": "Want to choose a public, easy spot and keep it low-pressure?",
      "wrap_up_warmClose": "I have liked this chat. Want to pick it back up later?",
      "wrap_up_pickUpLater": "I need to step away for now, but I would like to continue this later.",
      "wrap_up_goodChat": "This has been a good chat. Thanks for making it easy.",
      "wrap_up_nextTime": "Next time, I want to hear the rest of that story.",
      "wrap_up_sleep": "I am fading, but this was nice. Talk soon?",
      "wrap_up_checkIn": "Checking back in. Want to continue where we left off?"
    },
    "followUp": {
      "possibleIfAnswered": "Possible follow-up if they answer",
      "a11y": "Possible follow-up if they answer: {{prompt}}",
      "prompts": {
        "whatMadeItStandOut": "What made it stand out?",
        "whatMadeThatFeelLikeWin": "What made that feel like a win?",
        "whatWouldMakeItGood": "What would make that feel good to you?",
        "howDidYouLandThere": "How did you land on that opinion?",
        "whatLineOrMoment": "What line or moment keeps replaying for you?",
        "whereWouldYouGoAgain": "Where would you go again?",
        "whatChangedAfter": "Did anything change for you after that?",
        "wantMyVersion": "Want my version too?",
        "whatHappenedNext": "What happened next?",
        "easyOrInteresting": "Do you want an easy question or an interesting one?",
        "howWouldYouUseIt": "How would you use it in real life?",
        "defendYourChoice": "Defend your choice for one sentence.",
        "whatGenre": "What genre would today be?",
        "bestWorstCombo": "What is the best worst snack combo?",
        "whatWouldYouTry": "What would you try first?",
        "howStronglyHeld": "How strongly do you stand by that?",
        "whatGaveItThatTexture": "What gave it that texture?",
        "howDidItBecomeYours": "How did that become your thing?",
        "howOftenDoYouGetIt": "How often do you get to enjoy that?",
        "whatStartedThat": "What started that for you?",
        "whatShouldSomeoneOrder": "What should someone order there first?",
        "aloneOrWithCompany": "Would you spend it alone or with someone?",
        "whatWouldHelp": "What would help bring more of the good energy back?",
        "whatMadeItMatter": "What made it matter to you?",
        "whatShiftedIt": "What shifted it for you?",
        "whereDoesThatShowUp": "Where does that show up in everyday life?",
        "howCanPeopleTell": "How can people usually tell that helps you?",
        "whatRuinsIt": "What usually ruins a good day for you?",
        "wantASecondEasyOne": "Want a second easy one?",
        "pickOneEasy": "Pick one: food, music, outside, or sleep?",
        "youFirstOrMe": "Do you want to go first, or should I?",
        "whyThatOne": "Why that one?",
        "whatMakesItInteresting": "What makes it interesting to you?",
        "howSoon": "How soon are you looking forward to it?",
        "whatDayWorks": "What kind of day usually works for you?",
        "whatPaceFeelsGood": "What pace feels good to you?",
        "weekdayOrWeekend": "Weekday or weekend usually easier?",
        "whatFeelsEasy": "What would make it feel easy?",
        "wantToPickTime": "Want to pick a time window?",
        "whatSpotFeelsEasy": "What kind of spot feels easiest?"
      }
    },
    "more": "More",
    "moreA11y": "Show all Conversation Deck categories",
    "promptBadge": "Good for a new chat",
    "promptHint": "Easy to answer. Easy to build on.",
    "phraseMyself": "I'll phrase it myself",
    "less": "Less",
    "lessA11y": "Show fewer Conversation Deck categories",
    "promptBadges": {
      "start": "Good for a new chat",
      "keep_going": "Good for keeping it going",
      "fun": "Good for a lighter turn",
      "get_to_know": "Good for getting to know them",
      "go_deeper": "Good for a deeper moment",
      "make_a_plan": "Good for making a plan",
      "wrap_up": "Good for closing warmly"
    },
    "plusLock": {
      "title": "This deck is part of Opncue Plus",
      "body": "We want to keep Opncue ad-free and enjoyable to use. To make that possible, some decks and features are available with Opncue Plus.",
      "body2": "Your subscription helps us keep Opncue running, continue improving the app, and build new experiences for everyone.",
      "cta": "Upgrade to Plus",
      "dismiss": "Not now",
      "lockedA11y": "{{category}}, part of Opncue Plus"
    }
  }
}
